export default (blob, filename, type = 'text/plain') => {
  const a = window.document.createElement('a');
  a.href = window.URL.createObjectURL(blob, { type });
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};



// WEBPACK FOOTER //
// ./src/utils/download.js